import { FCX } from "@datassential/platform-ui-lib";
import { IFoodProfileMenuData } from "@models/FoodProfileMenu";
import { useMemo } from "react";
import './PairedFlavors.scss';
import FoodBarChart from "@pages/Food/components/BarChart/BarChart";

const ITEMS_COUNT = 5;

const Item: FCX<{
    name: string;
    value: number;
    proportionalValue: number;
    index: number;
}> = ({
    name,
    value,
    proportionalValue,
    index,
}) => {
    return (
        <div
            className="FoodPairedFlavors__item FoodSectionMenu__blur"
        >
            <div
                className="FoodPairedFlavors__item-title"
                data-testid={`textFoodMenuPairedFlavorsItemName-${index}`}
            >
                {name}
            </div>
            <div className="FoodPairedFlavors__item-content">
                <FoodBarChart
                    valuePct={proportionalValue}
                    colorStart="#006EF5"
                    colorStop="#00B4FF"
                    className="FoodPairedFlavors__item-bar"
                />
                <div
                    className="FoodPairedFlavors__item-value"
                    data-testid={`textFoodMenuPairedFlavorsItemValue-${index}`}
                >
                    {value}%
                </div>
            </div>
        </div>
    );
};

const PairedFlavors: FCX<{
    data: IFoodProfileMenuData['pairedFlavors'];
}> = ({
    data: rawData
}) => {

    const data = useMemo(
        () => {
            const result = [...rawData];

            result.sort((a, b) => {
                return b.value - a.value;
            });
            const maxCount = result[0]?.value ?? 0;

            return result
                .slice(0, ITEMS_COUNT * 2)
                .map(i => ({
                    ...i,
                    value: Math.round(i.value * 100),
                    proportionalValue: (i.value / maxCount) * 100,
                }));
        },
        [rawData]
    );

    const col1 = useMemo(
        () => data.slice(0, ITEMS_COUNT),
        [data]
    );

    const col2 = useMemo(
        () => data.slice(ITEMS_COUNT, ITEMS_COUNT * 2),
        [data]
    );

    return (
        <div className="FoodPairedFlavors">
            <div className="FoodPairedFlavors__col">
                {col1.map((item, index) => (
                    <Item
                        key={item.id}
                        name={item.name}
                        value={item.value}
                        proportionalValue={item.proportionalValue}
                        index={index}
                    />
                ))}
            </div>
            {col2.length > 0 && (
                <div className="FoodPairedFlavors__col">
                    {col2.map((item, index) => (
                        <Item
                            key={item.id}
                            name={item.name}
                            value={item.value}
                            proportionalValue={item.proportionalValue}
                            index={index + col1.length}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default PairedFlavors;